module.exports = __webpack_public_path__ + "static/media/Round.be8f3a98.png";